import { FormSubmissionsV2Types } from '../../../types';
import { BASE_ROUTE } from '../base';

export const FORMS_SUBMISSIONS_LIST: Record<
  FormSubmissionsV2Types.SubmissionListType,
  FormSubmissionsV2Types.SubmissionListType
> = {
  inbox: 'inbox',
  sent: 'sent',
  archived: 'archived',
};

export const FORMS_SUBMISSIONS_INBOX_LIST: Record<
  FormSubmissionsV2Types.SubmissionInboxListSubCategoryType,
  FormSubmissionsV2Types.SubmissionInboxListSubCategoryType
> = {
  all: 'all',
  'needs-review': 'needs-review',
  'retry-sync': 'retry-sync',
  completed: 'completed',
  reviewed: 'reviewed',
  'sync-manually': 'sync-manually',
};

export const BASE_SUBMISSION_V2_ROUTE = `${BASE_ROUTE}/submissions`;
